import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'

import { ROUTES } from '@/constants'
import { matchPathname } from '@/utils'

import { TGeneratorStep } from '../generatorTypes'

const getCurrentStep = (pathname: string): TGeneratorStep => {
	const stepMatchers: { route: string; step: TGeneratorStep }[] = [
		{ route: ROUTES.generator.typeStep, step: 'type' },
		{ route: ROUTES.generator.signup, step: 'design' },
		{ route: ROUTES.generator.designStep, step: 'design' },
		{ route: `${ROUTES.generator.typeStep}/:type`, step: 'content' },
	]

	const matchList = stepMatchers.map(({ route, step }) => ({
		step,
		match: matchPathname(pathname, route).match,
	}))

	const firstMatch = matchList.find(({ match }) => match)

	if (firstMatch) {
		return firstMatch.step
	}

	return 'type'
}

export const useCurrGeneratorStep = () => {
	const pathname = usePathname()

	const [currStep, setCurrStep] = useState<TGeneratorStep>(
		getCurrentStep(pathname),
	)

	useEffect(() => {
		const currStep = getCurrentStep(pathname)
		setCurrStep(currStep)
	}, [pathname])

	return currStep
}
